import { createContext, useContext } from 'react';

/**
 * ER VI ALLEREDE PÅ ET ARK? (Glass 2, DESIGN.md §16.5 punkt 8: «kort inni kort flates ut»).
 *
 * Et innholdskort (`Card`, en dialog) sier fra her, og det som tegnes inni — et `Card`, en `Table`,
 * en `GroupedTable` — tegner seg da uten egen ramme: kortet blir en seksjon med overskrift og én
 * skillelinje, tabellen blir rader rett på arket. Uten dette ble Advance tre nivåer med rammer, og
 * hver side måtte huske å be om den flate varianten selv.
 */
export const InsideSurface = createContext(false);

export function useInsideSurface(): boolean {
  return useContext(InsideSurface);
}
